
import { defineComponent } from "vue";
import EasyPieChart from 'easy-pie-chart';
import moment from "moment";
import { mapState, mapStores } from "pinia";
import WidgetBase, { WidgetMode } from "./widget.vue";
import { useDashboardStore } from "~/store/dashboard.store";
import WidgetContentBase from '~/components/widgets/widget-content-base';
import { Station } from "~/api/models/station.model";

const fake: Station = {
    "id": "6284fe2033742b160608063d",
    "name": "aura-0001-0004",
    "group_id": "6087d7a6037e556156137cfc",
    "group_name": "aura-co2",
    "location": {
        "lat": 45.19207209857447,
        "lon": 5.706631153651841
    },
    "type": "aura-co2",
    "status": "online",
    "last_seen": moment().subtract(5, 'minute').unix(),
    "image_url": null,
    "latest_values": { "CO2_alarm": 0, "CO2": 586, "temperature": 22.3, "humidity": 35, "pressure": 984, "mslPressure": 984, "SOC": 91, "CO2_aqi": 31, "aqi": 31 },
    "latest_values_units": { "CO2_alarm": null, "CO2": "ppm", "temperature": "degC", "humidity": "%", "pressure": "hPa", "mslPressure": "hPa", "SOC": "%" },
    "eid": "E11CD47102210014",
    "pairing_token": "E11CD47102210014",
    "latest_raw_values": { "CO2_error": 0, "rssi": -59, "snr": 10.5, "gateways_count": 2, "message_count": 295, "spreading_factor": 7, "battery": 3460 },
    "latest_raw_values_units": { "CO2_error": null, "rssi": "dB", "snr": "dB", "gateways_count": null, "message_count": null, "spreading_factor": null, "battery": "mV" },
    "calibration": { "battery": { "commissioningDate": "2022-06-02T06:44:09+0000" } },
    "metadata": { "AppEUI": "240504D07ED5B371", "AppKey": "32CFCC054AD9D438C8C7E542B6CA4603", "DevEUI": "E11CD47102210014", "FW_version": "nan", "PN": "AURA20LC221EU", "SN": "0221-0014", "elichens/public/color": "rgba(184, 31, 31, 1)", "elichens/public/label": "My Aura station", "elichens/public/locality": "Grenoble", "elichens/public/locality_long": "Grenoble, France", "elichens/public/location": "Meeting Room", "elichens/public/timezone_id": "Asia/Tokyo", "sensor_id": "nan", "stm_id": "nan", "elichens/aura-mobile-app": { "upgrades": [{ "date": "2022-10-18T13:55:34.783Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": false, "steps_done": ["init", "download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking"] }, { "date": "2022-10-18T14:03:58.265Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": false, "steps_done": ["init", "download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking"] }, { "date": "2022-10-18T14:11:34.455Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": false, "steps_done": ["init", "download-binaries", "transfert-binaries", "rebooting", "clean", "checking", "configuration"] }, { "date": "2022-10-26T08:13:42.540Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": false, "steps_done": ["init", "download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking"] }, { "date": "2022-10-26T08:45:11.442Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": false, "steps_done": ["download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking", "configuration"] }, { "date": "2022-10-26T08:55:12.087Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": true, "steps_done": ["init", "download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking", "configuration"] }, { "date": "2022-10-26T12:22:20.487Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": true, "steps_done": ["init", "download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking", "configuration"] }, { "date": "2022-10-26T12:30:00.585Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": true, "steps_done": ["init", "download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking", "configuration"] }, { "date": "2022-10-28T11:49:22.915Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": true, "steps_done": ["init", "download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking", "configuration"] }, { "date": "2022-10-28T12:12:38.482Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": true, "steps_done": ["init", "download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking", "configuration"] }, { "date": "2022-11-10T15:15:20.834Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": true, "steps_done": ["init", "download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking", "configuration"] }] }, "elichens/public/tz_offset": 32400 }
};

export default defineComponent({

    extends: WidgetContentBase,

    data() {
        return {
            config: {
                barColor: 'rgba(255,255,255,1)',
                trackColor: 'rgba(255,255,255,0.1)',
                scaleColor: 'rgba(255,255,255,1)',
                scaleLength: 5,
                lineCap: 'round',
                lineWidth: this.widget.height * 10,
                rotate: 0,
                animate: {
                    duration: 1000,
                    enabled: true,
                },
            },
            error: false,
            gauge: null,
            gaugeSize: Math.max(0.7 * (this.$refs.wrapper as HTMLDivElement)?.clientHeight, 208 * 0.7),
            lineWidth: Math.max(0.05 * (this.$refs.wrapper as HTMLDivElement)?.clientHeight, 208 * 0.05),
        }
    },

    mounted() {
        setTimeout(() => {
                try {
                    
                    this.error = false
                    this.gaugeSize = Math.max(0.7 * (this.$refs.wrapper as HTMLDivElement)?.clientHeight, 208 * 0.7);
                    this.lineWidth = Math.max(0.05 * (this.$refs.wrapper as HTMLDivElement)?.clientHeight, 208 * 0.05);
                    
                    if(!this.$refs.gauge) {
                        this.error = true;
                        return;
                    }

                    this.gauge = new EasyPieChart(this.$refs.gauge, { ...this.config, size: this.gaugeSize, lineWidth: this.lineWidth });
                    this.updateGauge();
                } catch (e) {
                    this.error = true;
                    this.$notifyError('Widget CO2 could not be initiated', e);
                }
            }, 200);
            
            this.$eventBus.on('grid.change', () => this.reset());
    },

    unmounted() {
        this.$eventBus.off('grid.change');
    },

    computed: {

        ...mapStores(useDashboardStore),
        ...mapState(useDashboardStore, ['aqiExt', 'currentStation']),

        station(): Station {
            return this.fake ? fake : this.currentStation;
        },
        
        airQuality(): number {
            const aqi: number = this.station?.latest_values?.aqi || 0;
            return aqi;
        },

        co2(): number {
            return this.station?.latest_values?.CO2 || 0;
        },

        co2Unit(): string {
            return this.station?.latest_values_units?.CO2 || 0;
        },

        airQualityLvl(): number {
            return Math.floor(this.airQuality / 25);
        },

        airQualityLabel(): string {
            const level = this.airQualityLvl;
            switch (level) {
                case 0:
                    return this.$t('dashboard.aqi.very_good');
                case 1:
                    return this.$t('dashboard.aqi.good');
                case 2:
                    return this.$t('dashboard.aqi.moderate');
                case 3:
                    return this.$t('dashboard.aqi.unhealthy');;
                case 4:
                    return this.$t('dashboard.aqi.very_unhealthy');
                default:
                    return '-';
            }
        },

        airQualityBackgroundClass(): string {

            const level = this.airQualityLvl;

            switch (level) {
                case 0:
                    return 'bg-aq-very-good';
                case 1:
                    return 'bg-aq-good';
                case 2:
                    return 'bg-aq-moderate';
                case 3:
                    return 'bg-aq-unhealty';
                case 4:
                    return 'bg-aq-very-unhealty';
                default:
                    return 'bg-aq-default';
            }
        },

        extAirQualityTextColorClass(): string {

            const level = Math.floor(this.aqiExt / 25);

            switch (level) {
                case 0:
                    return 'text-aq-very-good';
                case 1:
                    return 'text-aq-good';
                case 2:
                    return 'text-aq-moderate';
                case 3:
                    return 'text-aq-unhealthy';
                case 4:
                    return 'text-aq-very-unhealthy';
                default:
                    return 'text-aq-default';
            }
        },

        widgetHeight(): number {
            //@ts-ignore
            return this.$refs?.wrapper?.clientHeight || 200;
        },

        lastMeasureDate(): string {
            return moment.unix(this.dashboardStore.currentStation?.last_seen).fromNow();
        },

    },
    
    methods: {

        reset(): void {
            try {
                this.error = false
                const div = (this.$refs?.gauge as HTMLDivElement);
                if (div.firstChild) {
                    div.removeChild(div.firstChild);
                }
                this.gaugeSize = Math.max(0.7 * (this.$refs.wrapper as HTMLDivElement)?.clientHeight, 208 * 0.7);
                this.gauge = new EasyPieChart(this.$refs.gauge, { ...this.config, size: this.gaugeSize });
            } catch(e) {
                this.error = true;
                this.$notifyError('Widget CO2 could not be initiated', e);
            }
        },
        
        updateGauge(): void {
            if (!this.gauge) {
                return;
            }

            this.gauge?.update(Math.min(100, Math.max(0.1, this.airQuality)));
        },

        onWidgetClick(): void {
            if(this.editable) {
                return;
            }
            this.$router.replace({ path: this.$route ? this.$route.path : '', query: { ...this.$route.query, indicator: 'CO2' } });
        }

    },

    watch: {
        airQuality() {
            this.updateGauge();
        },
    }
});

